import * as React from 'react'

import getConfig from 'next/config'
import NextRouter from 'next/router'

import { Organization, StructuredDataTypes } from '@grandvision/analytics'
import {
  BrPageModel,
  CmsComponentSlot,
  CmsContainerPage,
  CmsPageLayout,
  getAlgoliaConfigFromBloomreach,
} from '@grandvision/bloomreach'
import {
  AlgoliaConfigProvider,
  AlgoliaConfigProviderProps,
  fetchAlgoliaConfig,
} from '@grandvision/search'

import { layoutProps } from '~/components/layout-props'
import { createAlgoliaConfig } from '~/util/algolia'

const { publicRuntimeConfig } = getConfig()
const defaultLocale = publicRuntimeConfig?.defaultLocale || 'nl-NL'

const organizationStructuredData: StructuredDataTypes.Organization = {
  '@type': 'Organization',
  name: 'Pearle Opticiens',
  legalName: 'Brilmij Groep B.V.',
  taxID: '31047357',
  vatID: 'NL805357233B01',
  url: publicRuntimeConfig.selfUrl,
  email: 'contact@pearle-post.com',
  telephone: '+318002745002',
  logo: `${publicRuntimeConfig.selfUrl}/img/pnl-vert-600.png`,
  address: [
    {
      '@type': 'PostalAddress',
      streetAddress: 'Antwoordnummer 3004',
      postalCode: '3760 VD',
      addressLocality: 'Soesterberg',
      addressCountry: 'Nederland',
    },
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+318002745001',
    contactType: 'customer service',
    areaServed: 'NL',
    contactOption: 'TollFree',
  },
}

type InitialProps = {
  algoliaConfig: AlgoliaConfigProviderProps
  pageModel: BrPageModel
}

type Props = InitialProps & {}

const ContainerPage = ({ algoliaConfig, pageModel }: Props) => {
  const isHomePage = pageModel?.page?.name === 'homepage'
  return (
    <CmsContainerPage>
      <CmsPageLayout {...layoutProps}>
        <AlgoliaConfigProvider {...algoliaConfig} NextRouter={NextRouter}>
          <CmsComponentSlot path="main" />
        </AlgoliaConfigProvider>
      </CmsPageLayout>
      {isHomePage && <Organization {...organizationStructuredData} />}
    </CmsContainerPage>
  )
}

ContainerPage.getInitialProps = async ({ req, query }): Promise<InitialProps> => {
  const algoliaConfig = await fetchAlgoliaConfig({
    ...createAlgoliaConfig(req.originalUrl, query?.pageModel, req.mediaQueryBreakpoint),
    ...getAlgoliaConfigFromBloomreach(query?.pageModel),
    locale: req.locale?.toString() || defaultLocale,
  })

  return { algoliaConfig, pageModel: query?.pageModel }
}

export default ContainerPage
